<template>
  <div class="searchBar">
    <div class="searchBarLeft">
      <!-- <el-select v-model="searchData.contractMoment" placeholder="请选择" @change="searchChange">
        <el-option
          v-for="item in contractMomentArr"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>-->
      <el-date-picker
        @change="searchChange"
        class="dataPickerCustom"
        v-model="searchData.signStartTimeBegin"
        value-format="yyyy-MM-dd"
        type="date"
        placeholder="开始日期"
      ></el-date-picker>
      <span>&nbsp;-&nbsp;-&nbsp;</span>
      <el-date-picker
        @change="searchChange"
        class="dataPickerCustom"
        value-format="yyyy-MM-dd"
        v-model="searchData.signStartTimeEnd"
        type="date"
        placeholder="结束日期"
      ></el-date-picker>
      <div class="dataRange">
        <span
          class="dateSp ft12 cursorPointer"
          :class="{'dataSpActive':item.active}"
          v-for="(item,index) in dataRang"
          :key="index"
          @click="dataRangeChange(item)"
        >{{item.name}}</span>
      </div>
      <span @click="selectAll" class="selectAll">全部</span>
    </div>
    <div class="searchBarRight">
      <el-input class="contractName" v-if="listFlag === 'failSign'" v-model="searchData.batchNo" placeholder="签署批次"></el-input>
      <el-input class="contractName" v-model="searchData.code" placeholder="合同编号"></el-input>
      <el-input class="contractName" v-model="searchData.contractName" placeholder="合同名称"></el-input>
      <span class="searchIcon cursorPointer" @click="searchChange"></span>
    </div>
  </div>
</template>
<script>
import storageUtil from "@lib/storageUtil.js";
import Util from "@lib/util.js";
export default {
  props: {
    listFlag: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      searchData: {
        signStartTimeBegin: "",
        signStartTimeEnd: "",
        contractName: "",
        dataRange: "",
        code: "",
        batchNo: "",
      },
      dataRang: [
        { name: "一周内", value: 1, active: false },
        { name: "一月内", value: 2, active: false },
        { name: "一年内", value: 3, active: false }
      ],
      signDeadlineDateOption: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 1000 * 60 * 60 * 24;
        }
      }
    };
  },
  mounted() {
    let temp = storageUtil.getSession(this.listFlag);
    if (temp) {
      this.searchData = temp;
      this.$forceUpdate();
      if (this.searchData.dataRange)
        this.dataRangeChange(this.searchData.dataRange, true);
    }
  },

  methods: {
    dataRangeChange(item, dontNotifyParent) {
      this.dataRang.forEach(value => {
        this.$set(value, "active", false);
        if (item.value == value.value) {
          this.$set(value, "active", true);
        } else {
          this.$set(value, "active", false);
        }
      });
      let current = new Date().getTime();
      let temp;
      if (item.value == 1) {
        temp = current - 7 * 1000 * 60 * 60 * 24;
      } else if (item.value == 2) {
        temp = current - 30 * 1000 * 60 * 60 * 24;
      } else if (item.value == 3) {
        temp = current - 365 * 1000 * 60 * 60 * 24;
      }
      this.searchData.dataRange = item;
      this.searchData.signStartTimeEnd = new Date(current).format();
      this.searchData.signStartTimeBegin = new Date(temp).format();
      this.searchChange();
    },
    selectAll() {
      this.searchData.signStartTimeBegin = "";
      this.searchData.signStartTimeEnd = "";
      this.searchData.contractName = "";
      this.searchData.dataRange = "";
      this.dataRang.forEach(value => {
        this.$set(value, "active", false);
      });
      this.searchChange();
    },
    searchChange() {
      if (
        this.searchData.signStartTimeBegin &&
        this.searchData.signStartTimeEnd
      ) {
        let startTime=new Date(this.searchData.signStartTimeBegin).getTime();
        
        let endTime=new Date(this.searchData.signStartTimeEnd).getTime();
        if(this.searchData.signStartTimeBegin>this.searchData.signStartTimeEnd){
          this.$message.error("开始时间不能大于结束时间");
          return;
        }
        // if (Util.compareTime(
        //     this.searchData.signStartTimeBegin,
        //     this.searchData.signStartTimeEnd
        //   )
        // ) {
        //   console.log()
        //   this.$message.error("开始时间不能大于结束时间");
        //   return;
        // }
      }
      !this.searchData.signStartTimeBegin &&
        (this.searchData.signStartTimeBegin = "");
      !this.searchData.signStartTimeEnd &&
        (this.searchData.signStartTimeEnd = "");
      if (this.listFlag == storageUtil.getSession("signHomeCurrentListFlag")) {
        let temp = storageUtil.getSession(this.listFlag);
        if (temp) {
          temp = Object.assign(temp, this.searchData);
        }
        storageUtil.setSession(this.listFlag, {
          ...this.searchData,
          pageNumber: 1,
          currentPage: 1
        });
        let newData={};
        for(let i in this.searchData){
          if(this.searchData[i] != undefined && this.searchData[i] != null ){
            newData[i]=this.searchData[i]
          }
        }
        this.$emit("searchChange", newData);
      }
    },
    getQuery() {
      return {
        signStartTimeBegin: this.searchData.signStartTimeBegin?this.searchData.signStartTimeBegin:'',
        signStartTimeEnd: this.searchData.signStartTimeEnd?this.searchData.signStartTimeEnd:'',
        contractName: this.searchData.contractName,
        dataRange: this.searchData.dataRange
      };
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.searchBar {
  .searchBarLeft {
    float: left;
  }
  .selectAll {
    font-size: 12px;
    line-height: 20px;
    padding: 0 12px;
    color: #db4437;
    cursor: pointer;
  }
  .searchBarRight {
    float: right;
    .contractName {
      width: 200px;
      height: 30px;
      margin-left: 16px;
      .el-input__inner {
        width: 200px;
        height: 30px;
        text-align: center;
      }
    }
    .searchIcon {
      display: inline-block;
      margin-left: 10px;
      vertical-align: top;
      width: 30px;
      height: 30px;
      background: url(./../../../../../assets/images/personalSignHome/search_icon_nor.png);
      background-size: 100%;
    }
    .searchIcon:hover {
      background: url(./../../../../../assets/images/personalSignHome/search_icon_pre.png);
    }
  }
  line-height: 30px;
  color: #c8c8c8;
  .el-select {
    padding-right: 10px;
    width: 100px;
    height: 30px;
    .el-input {
      height: 100%;
      width: 100%;
      input {
        height: 100%;
        width: 100%;
        line-height: 30px;
      }
    }
    .el-input__icon {
      height: 30px;
      line-height: 30px;
    }
    .el-input--suffix .el-input__inner {
      padding-right: 0px;
    }
  }
  .dataPickerCustom {
    width: 135px;
    height: 30px;
    .el-input__inner {
      height: 30px;
      line-height: 30px;
    }
    .el-input--suffix .el-input__inner {
      padding-right: 20px;
    }
    .input__inner {
      padding-right: 0;
    }
    .el-input__icon {
      line-height: 30px;
    }
  }
  .dataRange {
    display: inline;
    padding-left: 10px;
    .dateSp {
      margin-right: 10px;
      text-decoration: underline;
    }
    .dataSpActive {
      color: #db4437;
    }
  }
}
</style>
